import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { UpdateSeasonStageModel } from "~pages/SeasonStages/types/seasonStageModel.ts";
import type { StageResponse } from "~types/stage.ts";

export const useUpdateSeasonStage = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation<StageResponse, Error, UpdateSeasonStageModel>({
    mutationFn: async ({ stageCode, ...updateData }) =>
      await request<StageResponse>(`${sport}/o/${organizationId}/seasons/${seasonId}/stages/${stageCode}`, {
        method: "PUT",
        body: updateData,
      }),
    onSuccess: async (_, variables) => {
      notification.success({
        message: formatMessage({ id: "stage.update.success" }),
        placement: "bottomRight",
      });

      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["seasonStages", sport, organizationId, seasonId] }),
        queryClient.invalidateQueries({ queryKey: ["seasonStage", sport, organizationId, seasonId, variables.stageCode] }),
      ]);
    },
  });
};
